<template>

  <b-row>
    <b-col md="12">
      <b-card 
        no-body 
        :class="{ open: visibleBody }"
      >
        <b-card-header 
          :class="{ collapsed: !visibleBody }"  
          data-toggle="collapse"
          @click="() => visibleBody = !visibleBody"
          style="background-color: #0080C9; color: white; font:45px; padding:15px; padding: 1rem"
        >
          <span class="lead collapse-title"><strong>TERAPIAS</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse 
          v-model="visibleBody" 
          role="tabpanel"
        >
          <b-card-body style="padding: 1px">
            <div class="col-md-12" >

              <b-card class="mt-2 py-2" style="border: 1px solid #c9c9c9">
                <!-- <div
                  v-if="!terapiasList.length"
                  class="mb-2"
                > -->
                <div
                  
                  class="mb-2"
                >
                  <span  class="lead collapse-title"><strong>Terapia</strong></span>

                  <SearchOpts 
                    v-model="temp.terapia" 
                    :searchService="searchTerapiasByEstablecimientos"
                    :minChars="3"
                    :placeholder="'Buscar terapia...'"
                  />
                </div>
                

                <!-- Condicionales basados en el valor de titularsel -->
                <b-row v-if="temp.terapia">
                    
                  <b-col md="3">
                    <b-form-group label-for="v-cantidad">
                      <span>Numero de Sesiones</span>
                      <validation-provider #default="{ errors }" name="cantidad">
                        <b-form-input
                          id="v-cantidad"
                          v-model="temp.cantidad"
                          :state="errors.length > 0 ? false : null"
                          type="number"
                          min="1"
                          required
                          @keypress="validateKeyPress('cantidad', $event)"
                        />
                        <div v-if="errors.length" class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <validation-provider #default="{ errors }" name="norden" >
                      <span>Número de Orden</span>
                      <b-form-input 
                        id="v-norden" 
                        :state="errors.length > 0 ? false : null" 
                        v-model="temp.numeroOrden" 
                        type="number" 
                        @keypress="validateKeyPress('norden', $event)"
                      />
                    </validation-provider>
                  </b-col>

                  <b-col md="12">
                    <span>Motivo de Solicitud</span>
                    <b-form-textarea 
                      v-model="temp.motivoSolicitud"
                      placeholder="Escriba el motivo de la solicitud..." 
                      rows="2" 
                      no-resize
                    />
                  </b-col>

                  <b-col md="12">
                    <span>Resumen Clínico/Plan Terapeutico</span>
                    <b-form-textarea 
                      v-model="temp.resumenClinico"
                      placeholder="Escriba..." 
                      rows="2" 
                      no-resize
                    />
                  </b-col>

                  <b-col md="12" class="my-2 d-flex justify-content-end">
                    <b-button 
                      variant="info" 
                      size="sm" 
                      @click="agregarTerapia"
                      style="cursor: pointer;"
                    >
                      <span>Agregar</span>

                      <i 
                        class="fas fa-solid fa-plus ml-1" 
                        title="Agregar Terapia"
                      />
                    </b-button>
                  </b-col>
                </b-row>

                <b-col md="12" v-if="terapiasList.length" class="mt-1">

                  <!-- <b-table 
                    :items="terapiasList" 
                    :fields="fieldsTable" 
                    small 
                    responsive
                  >
                    <template #cell(terapia)="data">
                      {{ data.item.terapia }} 
                    </template>
                    <template #cell(acciones)="data">
                      <div class="d-flex justify-content-end">
                        <b-button 
                          variant="primary" 
                          size="sm" 
                          style="cursor: pointer;"
                          @click="editItem(data.item, data.index)"
                        >
                          <font-awesome-icon icon="user-pen" style="color: rgb(253, 253, 253);" />
                        </b-button>
                        <b-button variant="danger" size="sm" style="cursor: pointer;" @click="removeTerapia(data.item)">
                          <font-awesome-icon icon="circle-xmark" style="color: rgb(255, 255, 255);" />
                        </b-button>
                      </div>
                    </template>
                  </b-table> -->
                    
                </b-col>

                <b-alert
                  v-for="(item, index) in terapiasList"
                  :key="index" 
                  show 
                  :variant="getVariantCard(item.action)" 
                  class="my-1 p-1"
                >

                  <div class="d-flex justify-content-end align-items-center">
                    <span class="text-muted mr-1">{{ item.action.toUpperCase() }}</span>
                    <b-button 
                      :variant="showCardComplete.includes(index) ? 'info' : ''" 
                      size="sm" 
                      @click="onViewItem(index)"
                    >
                      <i class="fa-solid fa-magnifying-glass"/>
                    </b-button>

                    <b-button 
                      v-if="item.action !== 'eliminar'"
                      variant="danger" 
                      size="sm"
                      class="ml-1"
                      @click="onRemoveItemList(index)"
                    >
                      <i class="fa-solid fa-x"/>
                    </b-button>

                    <b-button 
                      v-if="item.action === 'eliminar'"
                      variant="warning" 
                      size="sm"
                      class="ml-1"
                      @click="onRestoreItem(index)"
                      title="Restaurar Item"
                    >
                      <i class="fa-solid fa-rotate-right"/>
                    </b-button>
                  </div>

                  <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
                    <strong class="col-2">N. Order: </strong> 
                    <span class="text-dark col">{{ item.numeroOrden }}</span>
                  </b-row>

                  <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
                    <strong class="col-2">Terapia: </strong> 
                    <span class="text-dark col">{{ item.terapia.text }}</span>
                  </b-row>

                  <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
                    <strong class="col-2">Cantidad: </strong> 
                    <span class="text-dark col">{{ item.cantidad }}</span>
                  </b-row>

                  

                  <span v-if="showCardComplete.includes(index)">
                    <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
                      <strong class="col-3">Motivo de solicitud: </strong> 
                      <span class="text-dark col">{{ item.motivoSolicitud }}</span>
                    </b-row>

                    <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
                      <strong class="col-3">Resumen/Plan Terapeutico: </strong> 
                      <span class="text-dark col">{{ item.resumenClinico }}</span>
                    </b-row>
                  </span>

                </b-alert>

              
              </b-card>

              <b-modal 
                id="edit-therapy-modal" 
                v-model="showEditTherapyModal" 
                title="Editar Terapia" 
                @hide="resetEditTherapyForm"
                ok-title="Guardar"
                @ok="onSubmitEditTherapy"
                cancel-title="Cancelar"
                @cancel="resetEditTherapyForm"
              >
                <b-form @submit.prevent="onSubmitEditTherapy">
                  <!-- Formulario de Edición de Terapia -->

                  <b-form-group label-for="edit-cantidad">
                    <label for="edit-cantidad"><strong>Cantidad</strong></label>
                    <b-form-input
                      id="edit-cantidad"
                      v-model="editTherapyForm.cantidad"
                      type="number"
                      min="0" 
                      required
                    />
                  </b-form-group>

                  <b-form-group label-for="edit-norden">
                    <label for="edit-norden"><strong>Número de Orden AS400</strong></label>
                    <b-form-input id="edit-norden" v-model="editTherapyForm.norden" type="text" required></b-form-input>
                  </b-form-group>

                  <b-form-group label-for="edit-motivosolicitud">
                    <label for="edit-motivosolicitud"><strong>Motivo de Solicitud</strong></label>
                    <b-form-textarea 
                      id="edit-motivosolicitud" 
                      v-model="editTherapyForm.motivosolicitud"
                      rows="2" 
                      required
                    />
                  </b-form-group>

                  <b-form-group label-for="edit-resumen">
                    <label for="edit-resumen"><strong>Resumen Clínico</strong></label>
                    <b-form-textarea 
                      id="edit-resumen" 
                      v-model="editTherapyForm.resumen"
                      rows="3" 
                      required
                    />
                  </b-form-group>
                </b-form>
              </b-modal>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
  

</template>

<script>
import 'flatpickr/dist/flatpickr.css';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { ValidationProvider } from 'vee-validate'

import { SearchOpts } from '@/shared/components';
import { terapiasCarteraService, terapiasService } from '../../../terapia/services';
import { loadRespaldo, saveRespaldo } from '../../helpers';



export default {
  components: {
    ValidationProvider,
    SearchOpts
  },

  data() {
    return {
      visibleBody: false,

      showCardComplete: [],

      temp:{
        terapia: null,
        cantidad: null,
        numeroOrden: null,
        motivoSolicitud: null,
        resumenClinico: null
      },

      terapiasList:[],

      searchText: '',
      continuar: false,
      alertaOmitida: 0,
      isLoading: false,
      searchFailed: false,
      noOptionsMessage: "Ingresa palabras clave para buscar.",
      selectedTerapia:null,
      visible: false,
      collapseItemID: '',
      searchQuery: '',
      openOnHover: this.$parent.hover,
      options: {},
      filteredTerapias:[],
      titulares: [],
      showEditTherapyModal: false,

      editTherapyForm: {
        cantidad: 0,
        norden: '',
        motivosolicitud: '',
        resumen: ''
        // Añade aquí cualquier otro campo necesario
      },
      cantidad: 0,
      norden: '',
      motivosolicitud: '',
      resumen: '',
      
      antecedentes: [],
      titularsel5:'',
      titularsel4:'',
      signosVitalesExisten: false, // Variable para verificar si existen Signos Vitales
      itemSignosVital: null,

      fieldsTable: [
        { key: 'terapia.text',   label: 'Terapia',              thClass: 'text-center' },
        { key:'cantidad',        label:'cantidad',              thClass:'text-center' },
        { key:'numeroOrden',     label:'Número de Orden AS400', thClass:'text-center' },
        { key:'motivoSolicitud', label:'Motivo de Solicitud',   thClass:'text-center' },
        { key:'resumenClinico',  label:'Resumen Clínico',       thClass:'text-center' },
        { key: 'acciones',       label: 'acciones',             thClass: 'text-center', tdClass: 'text-right', sortable: true, },
      ],
    };
  },
  created() {
    this.loadData();
  },


  methods: {

    async loadData(){

      this.idCita = this.$route.params.id;
      this.tokenAtencion = this.$route.params.token;

      this.identificadorAtencion = this.idCita ? this.idCita : this.tokenAtencion;

      if(this.idCita){
        const dataLS = loadRespaldo(this.identificadorAtencion, 'terapias');
        if(!dataLS)return;

        this.terapiasList = dataLS;
      }


      if(this.tokenAtencion){
        const responseTerapias = await terapiasService.getByAtencion(this.tokenAtencion);

          if(!responseTerapias) return;

          // filtrar solo activas
          const terapiasActivas = responseTerapias.filter(terapia => terapia.estado === '1');

          // map
          this.terapiasList = terapiasActivas.map(terapia => {

            const terapiaMap = {
              text: `(${terapia.terapia.codigo}) ${terapia.terapia.nombre}`,
              value: terapia.terapia.id,
            }

          return {
            action         : 'registrado',
            token          : terapia.token,
            terapia        : terapiaMap,
            numeroOrden    : terapia.numeroOrdenAs400,
            cantidad       : terapia.cantidad.toString(),
            motivoSolicitud: terapia.motivoSolicitud,
            resumenClinico : terapia.resumenClinico,
            idRegistro     : terapia.id,
            // justificacion  : terapia.justificacion,
          }
        });
      }

    },


    async searchTerapiasByEstablecimientos(search){
      const params = { search };

      const response = await terapiasCarteraService.getAll(params);

      if(!response) return [];

      const dataSelect = response.map(t => ({
        value: t.id,
        text: `(${t.codigo}) ${t.nombre}`,
        nombre: t.nombre,
        codigo: t.codigo
      }));

      return dataSelect;
    },


    getVariantCard(action){

      const variant = action === 'registrado' 
        ? 'success'
        : action === 'eliminar'
          ? 'danger'
          : 'info';

      return variant;
    },


    onViewItem(index) {
      const exists = this.showCardComplete.includes(index)

      this.showCardComplete = exists 
        ? this.showCardComplete.filter(item => item !== index)
        : [...this.showCardComplete, index];
    },



    async onRemoveItemList(index){

      const result = await this.$swal.fire({
        title: 'Eliminar Item Terapia',
        text: "Estas seguro de eliminar esta terapia?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      if (this.terapiasList[index].action === 'registrado'){
        this.terapiasList[index].action = 'eliminar';
        return;
      }

      this.terapiasList.splice(index, 1)
    },


    onRestoreItem(index){
      this.terapiasList[index].action = 'registrado'
    },


    async validateTerapiasEnviadas() {
      await terapiasService.getAll({ pacienteId:'1234' });
    },

  
    validateKeyPress(campo, event) {
      if (campo === "cantidad" && this.cantidad.length >= 2 && !['Backspace', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
      }
      if (campo === "norden" && this.norden.length >= 10 && !['Backspace', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
      }
    },

    


    // async fetchGetEstablecimiento(idCita) {
    //   const query = `
    //     query qrgetCitaById($id: String!){
    //       getCitaId(idCit: $id) {
    //         cita {
    //           id
    //           fechaCita
    //           horaCita
    //           estado
    //           establecimiento{
    //             id
    //           }
    //         }  
    //       }
    //     }
    //   `;

    //   const variables = {
    //     id: String(idCita),
    //   };

    //   try {
    //     const response = await axios.post(rutas.axios + 'api', { query, variables });
    //     if (response.status === 200) {
    //       return response.data.data.getCitaId.cita[0].establecimiento.id;
    //     }
    //   } catch (error) {
    //     console.error("Error fetching establecimiento id:", error);
    //     return -1;
    //   }
    // },



    editItem(item, index) {
      this.editTherapyForm = {
        ...JSON.parse(JSON.stringify(item)),
      };
      this.editingIndex = index;
      this.showEditTherapyModal = true;
    },


    resetEditTherapyForm() {
      this.editTherapyForm = this.getDefaultTherapyForm();
      this.editingIndex = null;
      this.showEditTherapyModal = false;
    },

    onSubmitEditTherapy() {
      // Verifica si todos los campos necesarios están llenos
      if ( !this.editTherapyForm.norden || !this.editTherapyForm.cantidad || !this.editTherapyForm.motivosolicitud || !this.editTherapyForm.resumen) {
        this.$swal({
          title: 'Campos Incompletos',
          text: 'Por favor, complete todos los campos requeridos antes de editar la terapia.',
          icon: 'warning',
          confirmButtonText: 'Ok'
        });
        return; // No realiza la edición si faltan campos
      }

      // Si todos los campos están llenos, continúa con la actualización de la terapia
      this.$set(this.terapias, this.editingIndex, this.editTherapyForm);
      this.showEditTherapyModal = false;
      this.editingIndex = null;
    },

    getDefaultTherapyForm() {
      return {
        selectedTerapia: null, // Cambia a 'titularsel2' si es lo que usas en tu modelo
        cantidad: 0,
        norden: '',
        motivosolicitud: '',
        resumen: '',
      };
    },

    removeTerapia(terapia) {
      this.$swal({
        title: '¿Estás seguro de eliminar?',
        text: "¡No podrás revertir esta acción!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
        cancelButtonText: 'No, cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          const index = this.terapias.indexOf(terapia);
          if (index > -1) {
            this.terapias.splice(index, 1);
            localStorage.setItem('atencionTerapias', JSON.stringify(this.terapias));
            this.$swal(
              'Eliminado!',
              'La terapia ha sido eliminada.',
              'success'
            );
          }
        }
      }).catch(error => {
        console.error("Error al eliminar la terapia:", error);
        this.$swal(
          'Error',
          'Ocurrió un error al intentar eliminar la terapia.',
          'error'
        );
      });
    },


    async showConfirmationDialog(title, text) {
      return new Promise((resolve) => {
        this.$swal({
          title: title,
          text: text,
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'No',
          confirmButtonText: 'Sí',
          confirmButtonColor: '#d9534f',
        }).then(result => {
          
          if(result.value){
            this.alertaOmitida = 1
          }
          resolve(result.value); // Resolve con true si se presionó Sí, false si No
          
        });
      });
    },


    async agregarTerapia() {

      if (!this.validarTerapia()) {
        this.$swal({
          title: 'Campos Incompletos',
          text: 'Por favor, complete todos los campos requeridos.',
          icon: 'warning',
          confirmButtonText: 'Ok'
        });
        return;
      }

      if (this.temp.cantidad > 10) {
        this.$swal({
          title: 'Error',
          text: 'No puede enviar mas de 10 sesiones de terapia.',
          icon: 'warning',
          confirmButtonText: 'Ok'
        });
        return;
      }

      this.alertaOmitida = 0;

      // this.validateTerapiasEnviadas();

      this.terapiasList.push(
        { 
          ...this.temp,
          action: 'crear',
        }
      );

      this.limpiarFormulario();
    },




    validarTerapia() {
      const validate = this.temp.terapia 
      && this.temp.numeroOrden 
      && this.temp.cantidad 
      && this.temp.motivoSolicitud 
      && this.temp.resumenClinico;

      return validate
    },

    limpiarFormulario() {
      this.temp = {
        terapia: null,
        numeroOrden: '',
        cantidad: 0,
        motivoSolicitud: '',
        resumenClinico: ''
      }
    },

  },


  watch: {

    terapiasList: {
      deep: true,
      handler(newValue) {
        
        if(this.identificadorAtencion){
          this.$store.commit("setTerapiasList", newValue);
          saveRespaldo(this.identificadorAtencion, 'terapias', newValue);
        }
      }
        
    }
  }
}


</script>
